import React from "react";
import {  Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useEffect } from "react";
import {
  DeleteInvalidICDZipcode,
  DeleteAllInvalidICDZipcode,
  GetLargeCliamInvalidICD10ZipDetails
} from "../../../../api/User/ACG/InvalidICDZipcodeApi";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";

const InvalidICDZipcode = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const column = [
    {
      title: "Error Value",
      field: "error_Value",
    },
    {
      title: "Error Type",
      field: "error_Type",
    },
    {
      title: "User Name",
      field: "user_Name",
    },
    {
      title: "License ID",
      field: "license_ID",
    },
    {
      title: "Date",
      field: "date",
    },
  ];

  useEffect(() => {
    getData();
    setSelectedRowData(null);
  }, []);

  const getData = () => {
    setIsLoading(true)
    GetLargeCliamInvalidICD10ZipDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err })).finally(res => setIsLoading(false))
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "deleteall"
              ? "Delete All "
              : "Delete "}
            Invalid ICD/Zip Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <DeleteModal
            onClickYes={() => {
              witchAction === "deleteall" ? DeleteAllInvalidICDZipcode().then((res) => {
                if(res.status === 200 || res.status === 204){
                toastFile("deleteall");
                setShowModal(false);
                }
              })
                :
                DeleteInvalidICDZipcode(selectedRowData).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setShowModal(false);
                  getData()
                  }
                })
            }}
            onClickNo={() => setShowModal(false)}
          />

        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        {/* <CustomButton
          onClick={() => {
            setWitchAction("deleteall");
            setShowModal(true);
          }}
        >
          Delete All Records
        </CustomButton> */}
      </div>
      <CustomMaterialTable
        isEdit={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default InvalidICDZipcode;
